import React from 'react';

const LanguageContext = React.createContext(true);

export const LanguageProvider = LanguageContext.Provider;
export default LanguageContext;
